import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Input,
  FormGroup,
  Label,
  Button,
  Spinner,
  Alert
} from "reactstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import createStory from "common/realBackend/blog/createBook";
import createEpisode from "common/realBackend/blog/createEpisode";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const TasksCreate = () => {
  document.title = "Create Story | AAOOA Admin";

  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Story Title is required"),
    type: Yup.string().required("Story Type is required"),
    description: Yup.string().required("Description is required"),
    coverImage: Yup.mixed().required("Cover Image is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Form values before submission:", values); // Log form data

    const { title, type, description, storyText, coverImage, audioLink, videoLinkString } = values;
    setLoading(true);
    try {

      await createStory(title, description, type, coverImage);
      setAlertMessage("Story created successfully!");

      setAlertVisible(true);
      resetForm();
      setCoverImagePreview(null);
    } catch (error) {
      console.error("Error creating:", error);
      setAlertMessage("Error creating. Please try again.");
      setAlertVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Stories" breadcrumbItem={"Create Story"} />

        {alertVisible && (
          <Alert color={alertMessage.includes("Error") ? "danger" : "success"}
            toggle={() => setAlertVisible(false)}
            style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 1050 }}>
            {alertMessage}
          </Alert>
        )}

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{"Create New Story"}</CardTitle>
                <Formik
                  initialValues={{
                    title: "",
                    type: "",
                    description: "",
                    coverImage: null,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue }) => (
                    <Form>
                      <FormGroup className="mb-4">
                        <Label htmlFor="title" className="col-form-label">Story Title</Label>
                        <Field
                          id="title"
                          name="title"
                          as={Input}
                          placeholder="Enter Book Title..."
                        />
                        <ErrorMessage name="title" component="div" className="text-danger" />
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Label htmlFor="type" className="col-form-label">Story Type</Label>
                        <Field as="select" name="type" className="form-control">
                          <option value="">Select Story Type...</option>
                          <option value="series">Series</option>
                          <option value="one-shot">One-Shot</option>
                        </Field>
                        <ErrorMessage name="type" component="div" className="text-danger" />
                      </FormGroup>


                      <FormGroup className="mb-4">
                        <Label htmlFor="description" className="col-form-label">Description</Label>
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          className="form-control"
                          placeholder="Enter a short description of the story..."
                          rows="5"
                        />
                        <ErrorMessage name="description" component="div" className="text-danger" />
                      </FormGroup>


                      <FormGroup className="mb-4">
                        <Label className="col-form-label">Cover Image</Label>
                        <Input
                          type="file"
                          className="form-control"
                          onChange={(e) => {
                            const file = e.currentTarget.files[0];
                            setFieldValue("coverImage", file);
                            setCoverImagePreview(URL.createObjectURL(file));
                          }}
                        />
                        {coverImagePreview && (
                          <div className="mt-2">
                            <img src={coverImagePreview} alt="Cover Preview" style={{ maxWidth: '250px', height: 'auto' }} />
                          </div>
                        )}
                        <ErrorMessage name="coverImage" component="div" className="text-danger" />
                      </FormGroup>

                      <Row className="justify-content-end">
                        <Col lg="10">
                          <Button type="submit" color="primary" disabled={loading}>
                            {loading ? <Spinner size="sm" /> : ("Create Story")}
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TasksCreate;
